module.exports = __webpack_public_path__ + "img/arrow-theme-down.93984427.svg";